// useProjectTypeValue.js
import { PROJECT_ENUM } from "./application.constants";
import useCurrentProject from "./useCurrentProject"; // Adjust the import path as needed

const useProjectTypeValue = () => {
  const currentProject = useCurrentProject();
  try {
    return currentProject && currentProject?.projectStatus && PROJECT_ENUM?.[currentProject?.projectStatus?.projectType]
  } catch (error) {
    return "";
  }
};

export default useProjectTypeValue;
